import AnchorLink from 'react-anchor-link-smooth-scroll'
import React from 'react'
import Link from 'gatsby-link'

import AboutUsComponent from 'components/AboutUsComponent'
import ContactComponent from 'components/ContactComponent'
import CtaComponent from 'components/CtaComponent'
import LeadComponent from 'components/LeadComponent'
import LeadComponentServices from 'components/LeadComponentServices'
import SeoComponent from 'components/SeoComponent'

class ThePage extends React.Component {
  render() {
    return (
      <div>
        <SeoComponent
          title='Meteor.js Programmierer in Köln. Wir sind Ihr Ansprechpartner!'
          description='Sind Sie auf der Suche nach Meteor.js Programmierern in Köln? Dann sind Sie bei uns genau richtig! Wir sind eine Agentur bei Köln und auf die Entwicklung mit Meteor.js spezialisiert. Schreiben Sie uns also gerne ein Nachricht und wir treffen uns auf einen leckeren Kaffee, um Ihr Projekt persönlich zu besprechen.'
        />
        <LeadComponent
          leadText='Meteor Programmierer Köln'
          subText='Wir sind eine Gruppe von <b>Programmierern bei Köln</b> und auf <b>Meteor.js</b> spezialisiert. <br/>Sehr gerne unterstützen wir Sie bei der Umsetzung Ihres Projektes.<br/><br/>Schreiben Sie uns also gerne eine Nachricht<br/>und wir besprechen Ihr Projekt persönlich.<br/>Telefonisch oder bei einer leckeren Tasse <i class="fas fa-coffee"></i> Kaffee…'
        />
        <LeadComponentServices imageStore={this.props.imageStore}/>
        <AboutUsComponent imageStore={this.props.imageStore}/>
        <CtaComponent/>
        <ContactComponent/>
      </div>
    )
  }
}
export default ThePage



// WEBPACK FOOTER //
// ./src/pages/meteor/meteor-programmierer-koeln.js